import { Component, OnInit } from '@angular/core';
import { EnvironmentconfigService } from 'src/app/shared/service/environmentconfig.service';
import { WebApiService } from 'src/app/shared/service/webapi.service';
import { AuthService } from 'src/app/shared/auth/auth.service';
import { URLConst } from 'src/app/shared/const/url.const';
import { NzMessageService } from 'ng-zorro-antd/message';
import { DateUtil } from 'src/app/shared/utils/date-format.util';
import { BaseComponent } from 'src/app/shared/base/base.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { HttpClient, HttpHeaders, HttpRequest, HttpResponse } from '@angular/common/http';
import { filter } from 'rxjs/operators';
import { MatomoTracker } from 'ngx-matomo';
import { LayoutComponent } from 'src/app/layout/layout.component';
import { TranslateService } from '@ngx-translate/core';
import { interval, Subscription } from 'rxjs';

interface SiteDto {
  siteCode: string;
  // 其他属性...
}
@Component({
  selector: 'app-SiteAdminRole',
  templateUrl: './wmsm-SiteAdminRole.component.html',
  styleUrls: ['./wmsm-SiteAdminRole.component.css']
})
export class WmsmSiteAdminRoleComponent extends BaseComponent implements OnInit {
  loading: boolean;
  isShowCondition: boolean = true;
  // 表格每页显示条数,默认每頁顯示10筆資料
  pageSize: number = 20;
  // 表格页码
  pageIndex: number = 1;
  nzTotal: number = 0;
  listOfData: any[] = [];
  fileList: NzUploadFile[] = [];
  isVisible = false;
  userOptionList = [];
  SiteList: any[];

  ExcelControl = [
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  ];
  needAddSiteAdminGroupText: string = '';
  pollingSubscription: Subscription;
  selectedUser: any = null;  // 存储选中的用户对象
  preLang = '';
  constructor(
    private Environment: EnvironmentconfigService,
    private webApiService: WebApiService,
    private messageService: NzMessageService,
    private AuthService: AuthService,
    private fb: FormBuilder,
    private http: HttpClient,
    private matomotracker: MatomoTracker,
    private LayoutComponent: LayoutComponent,
    private translate: TranslateService
  ) { super() }

  ngOnInit() {

    this.validateForm = this.fb.group({
      Site: [''],
      SubjectId: [''],
      SiteSelect: [''],
      SubjectIdSelect: ['']
    });

    this.LayoutComponent.geturl()
    this.GetSite()
    this.matomotracker.trackPageView("系統管理員權限設置")
    this.matomotracker.trackEvent("系統管理員權限設置", "SiteAdmin权限管控", "Transation", 1);
    this.getResultData();
    this.setNeedAddSiteAdminGroupText();
    this.preLang = localStorage.getItem('wmsmlang');
    this.pollingSubscription = interval(1000).subscribe(() => {
      this.languageChanged();
    });
  }
  ngOnDestroy(): void {
    if (this.pollingSubscription) {
      this.pollingSubscription.unsubscribe();
    }
  }

  //切换每页数据条数
  nzPageSizeChange(event: number): void {
    if (this.nzTotal === 0) {
      return;
    }
    this.pageSize = event;
    if (event * this.pageIndex > this.nzTotal && this.pageIndex > 1) {
      this.pageIndex--;
    }
    this.getResultData();
  }
  //切换页码
  nzPageIndexChange(event: number): void {
    this.pageIndex = event;
    this.getResultData();
  }

  onSearch() {
    this.isShowCondition = !this.isShowCondition;

    this.getResultData()
  }

  handleCancel(): void {
    this.isVisible = false;
  }

  handleOk(): void {
    this.submit()

    this.isVisible = false;
  }

  showModal() {
    // 打开弹窗时重置选择状态
    this.validateForm.controls['Site'].setValue('');
    this.validateForm.controls['SubjectId'].setValue(null);
    this.selectedUser = null;
    this.userOptionList = [];
    this.isVisible = true;
  }

  // 处理用户选择
  onUserSelect(userId: string) {
    if (userId) {
      this.selectedUser = this.userOptionList.find(u => u.userId === userId) || null;
    } else {
      this.selectedUser = null;
    }
  }

  Delete(value) {
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.DeleteSiteAdminRole.url}`;
    const params = {
      SiteNo: value.siteNo,
      SiteName: value.siteName,
      SubjectId: value.subjectId,
      SubjectName: value.subjectName,
      Maintainer: value.maintainer,
      MaintainerDate: new Date(),
    };
    this.webApiService.doPost(url, params).subscribe(
      (res) => {
        if (res.status == 200) {
          this.messageService.success("删除成功");
          this.getResultData();
        }
      },
      (error) => {

      }
    );
  }


  userSearch(event) {
    this.loading = true
    event = event.trim().toUpperCase();
    if (event.length >= 1) {
      const url = `${this.Environment.authConfig.MVMBackEnd}${URLConst.QueryUser.url}` + event;
      setTimeout(() => {
        this.webApiService.doGet(url).toPromise().then(
          (res) => {
            this.loading = true;
            this.userOptionList = res.data.slice(0, 10);
            this.loading = false
          },
          (error) => {
            this.messageService.error(error.msg);
            this.loading = false
          }
        );
      }, 800);

    }
    this.loading = false
  }


  // 获取查询表格数据
  getResultData() {
    this.loading = true;
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.GetMatainRoleList.url}`;
    const params = {
      pageSize: this.pageSize,
      pageIndex: this.pageIndex,
      data: {
        SiteNo: this.validateForm.controls['SiteSelect'].value,
        SubjectId: this.validateForm.controls['SubjectIdSelect'].value,
      },
    };
    this.webApiService.doPost(url, params).subscribe(
      (res) => {
        if (
          res &&
          res.status == this.Environment.authConfig.wmsmStatus
        ) {
          this.listOfData = res.data.map((item) => {
            item.maintainerDate = DateUtil.formatYMD(item.maintainerDate);
            this.loading = false;
            return item;
          });
          this.nzTotal = res.total;
          this.translate.get('QuerySuccess').subscribe((translatedText: string) => {
            this.messageService.success(translatedText);
          })
        } else {
          this.listOfData = [];
          this.nzTotal = 0;
          this.messageService.warning(res.msg);
        }
        this.loading = false;
      },
      (error) => {
        this.messageService.error(error.msg);
        this.loading = false;
      }
    );
  }

  //getsite
  GetSite() {
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.GetGoLiveSite.url}`;
    const params = {
    };
    this.webApiService.doPost(url, params).subscribe(
      (res) => {
        this.SiteList = res.data.siteListDto.sort(this.compare);
        this.loading = false;
      },
      (error) => {

      }
    );
  }


  submit() {
    // 验证必须选择搜索出来的用户
    if (!this.selectedUser) {
      this.translate.get('PleaseSelectUser').subscribe((translatedText: string) => {
        this.messageService.warning(translatedText);
      });
      return;
    }
    if (!(this.validateForm.controls['Site']?.value)) {
      this.translate.get('PleaseSelectSite').subscribe((translatedText: string) => {
        this.messageService.warning(translatedText);
      });
      return;
    }

    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.MatainSiteAdminRole.url}`;
    const params = {
      SiteNo: this.validateForm.controls['Site'].value || '',
      SiteName: this.SiteList.filter(o => o.siteCode == this.validateForm.controls['Site'].value).map(p => p.siteName)[0],
      SubjectId: this.selectedUser.userId,
      SubjectName: this.selectedUser.englishName || this.selectedUser.username,
      Maintainer: this.AuthService.getCurrentUserInfo().userId,
      MaintainerDate: new Date(),
    };
    this.loading = true;
    this.webApiService.doPost(url, params).subscribe(
      (res) => {

        if (res.status == "0000") {

          this.messageService.error(res.msg);
          this.loading = false;
        } else {
          this.messageService.success(res.msg);
          this.getResultData()
          this.loading = false;
        }
      },
      (error) => {
        this.loading = false;
        this.messageService.error(error.msg);
      }
    );
  }
  compare(a: SiteDto, b: SiteDto): number {
    const nameA = a.siteCode.toUpperCase(); // 忽略大小写进行比较
    const nameB = b.siteCode.toUpperCase();

    if (nameA < nameB) {
      return -1;  // a 在 b 前面
    }
    if (nameA > nameB) {
      return 1;  // a 在 b 后面
    }
    return 0;  // 名称相同
  }

  setNeedAddSiteAdminGroupText() {
    const url = `${this.Environment.authConfig.MVMBackEnd}${URLConst.GetUserGroupList.url}`;
    this.webApiService.doPost(url, {}, false, true).subscribe(res => {
      if (res && res.rc === 0 && res.data) {
        const siteAdminDisplay = res.data.find(x => x.userGroupId?.toString() === '23')?.userGroupName;
        const addUserGroupDisplay = `${this.translate.instant('Setting')}->${this.translate.instant('AccountPermissions')}->${this.translate.instant('UserGroupMapMenu')}`;
        this.needAddSiteAdminGroupText = this.translate.instant('NeedAddSiteAdminUserGroup').replace('{0}', siteAdminDisplay)
          .replace('{1}', addUserGroupDisplay);
      }
    });
  }
  languageChanged() {
    const currentLang = localStorage.getItem('wmsmlang');
    //有些欄位會依據語系從DB帶不同資料過來,因此當切換語系之後,要重新載入以刷新db資料
    if (currentLang !== this.preLang) {
      this.preLang = currentLang;
      this.setNeedAddSiteAdminGroupText();
    }
  }
}
